import 'Magaele/ps_lnls/css.scss';
import 'Magaele/ntb_gpbt/css.scss';
import 'Magaele/cy_lsgp/css.scss';
import 'Magaele/cd_gpcb/css.scss';
import 'Magaele/bt_gppp/css.scss';
import 'Magaele/bt_gptr/css.scss';
import 'Magaele/cd_gpfl/css.scss';
import 'Magaele/ic-ln/css.scss';
import 'Magaele/bt_slbx/css.scss';
import 'Magaele/clp_gplt/css.scss';
import 'Magaele/cd_gpdy/css.scss';
import 'Magaele/nvb_gptb/css.scss';
import 'Magaele/st_lnls/css.scss';
import 'Magaele/bt_gplt/css.scss';
import 'Magaele/clp_gpby/css.scss';
import 'Magaele/mdl_lnls/css.scss';
import 'Magaele/th_gplt/css.scss';
import 'Magaele/tp_gplt/css.scss';
import 'Magaele/tp_gpls/css.scss';
import 'Magaele/lb_gplt/css.scss';
import 'Magaele/tb_gplx/css.scss';
import 'Magaele/pp_ln/css.scss';
import 'Magaele/cy-ln/css.scss';
import 'Magaele/fcl_lnls/css.scss';


import "../css/css.scss"; 


// WEBPACK FOOTER //
// ./entry/products_style.entry.js